import classNames from 'classnames'
import React, { FC, ReactNode } from 'react'

import s from './WixMobileContentWrapper.scss'

type WixMobileContentWrapperProps = {
  className?: string
  dataHook?: string
  children?: ReactNode
}

export const WixMobileContentWrapper: FC<WixMobileContentWrapperProps> = ({ children, className, dataHook }) => {
  return (
    <div className={classNames(s.wrapper, className)} data-hook={dataHook}>
      {children}
    </div>
  )
}
